import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Bookmarks() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/bookmarks").then((r) => setItems(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const remove = async (qid) => {
    try {
      await api.delete(`/bookmarks/${qid}`);
      toast.success("Removed");
      load();
    } catch (e) { toast.error("Could not remove"); }
  };

  return (
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[hsl(var(--brand-orange))]">Bookmarks</div>
          <h1 className="mt-1 font-display text-3xl font-bold">Saved for revision</h1>
        </div>
        <Button asChild variant="outline" data-testid="bookmarks-revision-btn">
          <Link to="/quiz/new?mode=revision">Start revision quiz</Link>
        </Button>
      </div>
      {loading ? (
        <div className="text-sm text-muted-foreground">Loading...</div>
      ) : items.length === 0 ? (
        <Card><CardContent className="p-10 text-center text-sm text-muted-foreground">
          No bookmarks yet. Bookmark questions during a quiz to see them here.
        </CardContent></Card>
      ) : (
        <div className="space-y-3">
          {items.map((q) => (
            <Card key={q.id} className="border-border/70">
              <CardContent className="p-5">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1">
                    <div className="text-xs text-muted-foreground">{q.subject_name}{q.topic_name && ` · ${q.topic_name}`} · {q.difficulty}</div>
                    <div className="mt-1 font-display font-semibold">{q.text}</div>
                    <div className="mt-3 grid gap-2 text-sm">
                      {Object.keys(q.options).sort().map((k) => (
                        <div key={k} className={`rounded border px-3 py-2 ${q.correct_option === k ? "border-emerald-500 bg-emerald-50 font-medium" : "border-border"}`}>
                          <span className="mr-2 font-bold">{k}.</span>{q.options[k]}
                        </div>
                      ))}
                    </div>
                    {q.explanation && (
                      <div className="mt-3 rounded-lg bg-secondary/60 px-3 py-2 text-sm">{q.explanation}</div>
                    )}
                  </div>
                  <Button size="icon" variant="ghost" onClick={() => remove(q.id)} data-testid={`bookmark-remove-${q.id}`}>
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
